<div class="main-container">
  <div class="description-container">
    <h1 class="title">
      {{ "REGISTER.BACKUP_CONTACT.CONTACT" | translate }}
    </h1>
    <p class="text">
      {{ "REGISTER.BACKUP_CONTACT.DESCRIPTION" | translate }}
    </p>
  </div>
  <form
    [formGroup]="backupForm"
    class="form-container"
    (ngSubmit)="onContinue()"
  >
    <div class="inputs-container">
      @if (state.hasServerSideError) {
        <c-banner
          [lang]="lang"
          class="backup-contact-banner-error"
          iconPositionX="top"
          [style]="
            state.errorType === 'email-already-used' ? 'warning' : 'error'
          "
          [message]="
            state.errorType === 'gateway-timeout'
              ? ('REGISTER.GENERIC_FORM.ERRORS.GENERIC-GATEWAY-TIMEOUT'
                | translate)
              : state.errorType === 'email-already-used'
                ? ('REGISTER.BACKUP_CONTACT.ERRORS.EMAIL-ALREADY-USE'
                  | translate)
                : ''
          "
        >
          @if (state.errorType === "generic-error") {
            <div class="banner-message">
              <span>
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-1"
                    | translate
                }}
              </span>
              <span>
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-2"
                    | translate
                }}
              </span>
              <a class="banner-link" href="mailto:support@cariloop.com">
                {{
                  "REGISTER.GENERIC_FORM.ERRORS.GENERIC-SERVER-PART-3"
                    | translate
                }}
              </a>
            </div>
          }
        </c-banner>
      }
      <div role="status" class="screen-reader-only">
        @if (currentRadioSelected === "email") {
          <p>
            {{ "REGISTER.BACKUP_CONTACT.EMAIL_RADIO_SELECTED" | translate }}
          </p>
        }
        @if (currentRadioSelected === "phone") {
          <p>
            {{ "REGISTER.BACKUP_CONTACT.PHONE_RADIO_SELECTED" | translate }}
          </p>
        }
      </div>
      @if (showEmailInput()) {
        <div class="input-container">
          <div class="full-width">
            <div class="input-wrapper">
              <label for="backup-contact-email" class="input-label">
                {{ "REGISTER.BACKUP_CONTACT.INPUT_EMAIL" | translate }}
                <span class="optional-label">
                  {{ "REGISTER.BACKUP_CONTACT.OPTIONAL" | translate }}
                </span>
              </label>
              <c-input-text
                class="full-width backup-contact-input--email"
                formControlName="email"
                name="email"
                type="text"
                inputID="backup-contact-email"
                autocomplete="email"
                [placeholder]="
                  'REGISTER.BACKUP_CONTACT.EMAIL_PLACEHOLDER' | translate
                "
              >
              </c-input-text>
            </div>
            <div role="alert">
              @if (
                backupForm.get("email").touched &&
                !backupForm.get("email").valid
              ) {
                <p class="input__error-message">
                  {{ "REGISTER.BACKUP_CONTACT.EMAIL_ERROR" | translate }}
                </p>
              }
            </div>
          </div>
        </div>
      }
      <div class="input-container">
        <div class="full-width">
          <c-intl-tel-input
            name="phone"
            [required]="true"
            formControlName="phone"
            (phoneNumberChange)="validatePhoneInput($event)"
            [initialCountry]="initialCountry"
          >
            @if (
              backupForm.get("phone").touched &&
              backupForm.get("phone")?.errors?.required
            ) {
              <span>{{
                "REGISTER.BACKUP_CONTACT.PHONE_ERROR_REQUIRED" | translate
              }}</span>
            }
            @if (
              backupForm.get("phone")?.errors?.invalidPhoneNumber &&
              !backupForm.get("phone")?.errors?.required &&
              backupForm.get("phone").touched
            ) {
              <span>{{
                "REGISTER.BACKUP_CONTACT.PHONE_ERROR" | translate
              }}</span>
            }
          </c-intl-tel-input>
        </div>
      </div>
    </div>
    <div class="checkbox-container">
      <label class="checkbox">
        <input type="checkbox" formControlName="consentMarketing" />
        <span>{{ "REGISTER.BACKUP_CONTACT.CONSENT" | translate }}</span>
      </label>
    </div>

    <button
      cari-button
      type="submit"
      [disabled]="state.isSubmitting"
      data-shape="squared"
      data-type="neutral"
      data-style="fill"
      data-size="x-large"
      class="brand-submit-btn"
    >
      {{ "REGISTER.BACKUP_CONTACT.CONTINUE" | translate }}
    </button>
  </form>
  <div class="terms-container">
    <p>
      {{ "REGISTER.BACKUP_CONTACT.PRIVACY_DESCRIPTION" | translate }}
      <a
        aria-label="Privacy Policy"
        href="https://www.cariloop.com/privacy-policy/"
        target="_blank"
        >{{ "REGISTER.BACKUP_CONTACT.PRIVACY_POLICY_LINK" | translate }}</a
      >
      {{ "REGISTER.BACKUP_CONTACT.AND" | translate }}
      <a
        aria-label="Terms of service"
        href="https://www.cariloop.com/terms-of-service/"
        target="_blank"
        >{{ "REGISTER.BACKUP_CONTACT.TERMS_OF_SERVICE_LINK" | translate }}</a
      >.
    </p>
  </div>
</div>
